(function () {
  const TAG_SEPARATOR = '| color:';
  const OPTION_NAME = 'Farbe';

  function getColorFromAlt(alt) {
    if (!alt) return null;
    const pos = alt.toLowerCase().indexOf(TAG_SEPARATOR.toLowerCase());
    if (pos === -1) return null;
    return alt.slice(pos + TAG_SEPARATOR.length).trim().toLowerCase();
  }

  function filterGallery(color) {
    if (!color) return;

    // Modiva-spezifische Selektoren
    const slides = document.querySelectorAll(
      '.product-media-gallery__item, .product-thumbnails__item, .product__media-wrapper .media'
    );

    slides.forEach((slide) => {
      const img = slide.querySelector('img');
      if (!img) return;

      const altColor = getColorFromAlt(img.alt);

      if (!altColor) {
        slide.style.display = '';
      } else if (altColor === color) {
        slide.style.display = '';
      } else {
        slide.style.display = 'none';
      }
    });
  }

  function getColorFromVariant(variant) {
    if (!variant?.options) return null;
    // Option-Index ermitteln
    const idx = window.__colorOptionIndex ?? 0;
    return variant.options[idx]?.toLowerCase().trim() ?? null;
  }

  function resolveColorOptionIndex() {
    if (window.__colorOptionIndex !== undefined) return;

    // Modiva nutzt data-option-name auf den Swatch-/Select-Elementen
    const optionEls = document.querySelectorAll(
      '[data-option-name], [data-option-position]'
    );
    optionEls.forEach((el) => {
      const name = el.dataset.optionName ?? el.getAttribute('aria-label') ?? '';
      if (name.toLowerCase() === OPTION_NAME.toLowerCase()) {
        const pos = el.dataset.optionPosition;
        window.__colorOptionIndex = pos
          ? parseInt(pos, 10) - 1
          : Array.from(optionEls).indexOf(el);
      }
    });

    // Fallback
    if (window.__colorOptionIndex === undefined) {
      window.__colorOptionIndex = 0;
    }
  }

  function initFromDOM() {
    const productJson = document.querySelector(
      'script[type="application/json"][data-product-json], ' +
      'script#ProductJson-product-template, ' +
      // Modiva speichert Produktdaten häufig hier:
      'script[data-section-type="product"][type="application/json"]'
    );
    if (!productJson) return;

    try {
      const product = JSON.parse(productJson.textContent);

      // Option-Index über Produktdaten absichern
      if (window.__colorOptionIndex === undefined) {
        product.options?.forEach((opt, i) => {
          if (opt.toLowerCase() === OPTION_NAME.toLowerCase()) {
            window.__colorOptionIndex = i;
          }
        });
      }

      const selectedInput =
        document.querySelector('input[name="id"][form]') ??
        document.querySelector('input[name="id"]');

      if (selectedInput) {
        const variant = product.variants.find(
          (v) => String(v.id) === String(selectedInput.value)
        );
        if (variant) {
          const color = getColorFromVariant(variant);
          filterGallery(color);
        }
      }
    } catch (e) {
      console.warn('FLSK Gallery Filter: Produktdaten nicht lesbar', e);
    }
  }

  function init() {
    resolveColorOptionIndex();

    // Modiva feuert 'variant:change' (wie Horizon),
    // aber auch das ältere 'variantChange' — beide abfangen
    document.addEventListener('variant:change', (e) => {
      resolveColorOptionIndex();
      const variant = e.detail?.variant ?? e.detail?.currentVariant;
      if (!variant) return;
      filterGallery(getColorFromVariant(variant));
    });

    document.addEventListener('variantChange', (e) => {
      resolveColorOptionIndex();
      const variant = e.detail?.variant ?? e.detail?.currentVariant;
      if (!variant) return;
      filterGallery(getColorFromVariant(variant));
    });

    initFromDOM();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
